import { checkEU28 } from "./utils/checkEU28";

const options = {
  id: 'GEO-LAYER',
  style: function (feature) {
    const { properties } = feature;
    return {
      fillColor: properties['color'],
      weight: 1,
      opacity: 1,
      color: '#606060',
      dashArray: '0',
      fillOpacity: 1
    };
  }
};

export default options;